import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import DataTable from "../components/DataTable";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { useAuth } from "../contexts/AuthContext";
import BorrowerFormDialog from "../components/forms/BorrowerFormDialog";
import { Plus } from "lucide-react";

export default function Borrowers() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const { user } = useAuth();
  const navigate = useNavigate();

  const canWrite = user && (user.role === "admin" || user.role === "credit_officer");

  const load = () => {
    setLoading(true);
    api.get("/borrowers").then((r) => setData(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps -- load once on mount

  return (
    <div className="p-8 max-w-[1600px] mx-auto" data-testid="borrowers-page">
      <PageHeader
        title="Borrower"
        subtitle={`${data.length} borrower aktif dalam sistem`}
        action={canWrite && (
          <Button data-testid="add-borrower-button" onClick={() => { setEditing(null); setDialogOpen(true); }}>
            <Plus className="h-4 w-4 mr-1" /> Tambah Borrower
          </Button>
        )}
        testId="borrowers-header"
      />

      {loading ? (
        <div className="text-sm text-muted-foreground">Memuat data…</div>
      ) : (
        <DataTable
          testId="borrowers-table"
          columns={[
            { header: "Borrower ID", key: "borrower_id", cell: (r) => <span className="mono">{r.borrower_id}</span> },
            { header: "CIF", key: "cif", cell: (r) => <span className="mono text-xs">{r.cif}</span> },
            { header: "Nama", key: "name", cell: (r) => (
              <button className="font-medium text-left hover:underline" onClick={() => navigate(`/borrowers/${r.borrower_id}`)} data-testid={`borrower-${r.borrower_id}-link`}>
                {r.name}
              </button>
            ) },
            { header: "Tipe", key: "borrower_type" },
            { header: "Sektor", key: "sector" },
            { header: "Risk Rating", key: "risk_rating", cell: (r) => <Badge variant="outline" className="mono">{r.risk_rating}</Badge> },
            { header: "Business Unit", key: "business_unit", cell: (r) => <span className="text-xs">{r.business_unit}</span> },
            { header: "Status", key: "status", cell: (r) => (
              <Badge variant={r.status === "Active" ? "default" : "secondary"}>{r.status}</Badge>
            ) },
            ...(canWrite ? [{
              header: "Aksi", cell: (r) => (
                <Button size="sm" variant="ghost" onClick={() => { setEditing(r); setDialogOpen(true); }} data-testid={`edit-borrower-${r.borrower_id}`}>Edit</Button>
              )
            }] : []),
          ]}
          data={data}
          searchKeys={["borrower_id", "cif", "name", "sector"]}
        />
      )}

      <BorrowerFormDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        initial={editing}
        onSaved={() => { setDialogOpen(false); load(); }}
      />
    </div>
  );
}
